"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/TypeString.js";
function TypeString(_ref) {
  var onChange = _ref.onChange,
    field = _ref.field;
  function _onChange(value) {
    var where = {};
    where[field] = {
      $regex: value,
      $options: 'i'
    };
    onChange(where);
  }
  return /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    className: "form-control form-control-sm shadow-none w-auto rounded-0 rounded-end",
    placeholder: "Search",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  });
}
var _default = TypeString;
exports["default"] = _default;